import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Partners from "./components/Partners";
import Cases from "./components/Cases";
import Opportunity from "./components/Opportunity";
import Products from "./components/Products";
import Earnings from "./components/Earnings";
import Career from "./components/Career";
import License from "./components/License";
import Executive from "./components/Executive";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/toaster";

const LandingPage = () => (
  <div className="bg-white text-slate-900 overflow-x-hidden">
    <Header />
    <Hero />
    <Partners />
    <Cases />
    <Opportunity />
    <Products />
    <Earnings />
    <Career />
    <License />
    <Executive />
    <FAQ />
    <Contact />
    <Footer />
    <ChatWidget />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
